export default __webpack_public_path__ + "static/media/exercise-correct.f191c88e.svg";